import styled from 'styled-components';
import { grid } from './constants';
import { StepColors } from '../types';

interface TitleProps {
    isDragging?: boolean;
    step?: string;
}

// $ExpectError - not sure why
export default styled.h4<TitleProps>`
  padding: ${grid}px;
  background-color: ${
    ({ step }) => (
      step && step in StepColors
        ? StepColors[step as keyof typeof StepColors]
        : "transparent"
    )
  };
  color: white;
  flex-grow: 1;
  user-select: none;
  position: relative;
  &:focus {
    outline: 2px solid #998dd9;
    outline-offset: 2px;
  }
  border-top-left-radius: ${grid}px;
  border-top-right-radius: ${grid}px;
`;
